export default __webpack_public_path__ + "static/media/leaderboardbonustwo.f505db1b.png";